module.exports = __webpack_public_path__ + "img/Image_2__Second_Canal_996_10_3_Lock_no_23_Thorold.5a435cd7.jpg";